import React from 'react'
import FLHeader from './FLHeader'

// TODO: Add terms of service content
export default function FLDeleteAccount() {
    return (
        <div className="fl">
            <FLHeader subtitle="Delete Account"/> 
            <main className="fl__content">
                <p className="fl__intro">
                    If you would like to permanently delete your FitnessLogger account and associated workout data, 
                    enter the email address associated with your account below.
                </p>
                <p>Email: contact@solopixeldev.co.uk</p>
                
            </main>
        </div>
        
        
    )
}